import { Elements } from '@stripe/react-stripe-js';
import { FaCreditCard } from 'react-icons/fa';
import { PaymentForm } from './StripePaymentForm';
import vegasImage from 'assets/images/vegas-conference-image.png';
import Stepper from './Stepper';
import SectionCard from './SectionCard';
import PersonalInfo from './PersonalInfo';
import AttendanceDetails from './AttendanceDetails';
import AdditionalPersons from './AdditionalPersons';
import PaymentSummary from './PaymentSummary';
import {
  StepWrapper,
  VegasBackground,
  VegasHeader,
  VegasFooterButtons
} from 'components/VegasConference';

const Body = ({ _this }) => {
  const { step, setStep, form, setForm, clientSecret, stripePromise, validateStep1, totalAmount } =
    _this;

  const isStep1Valid = validateStep1();

  return (
    <div className="flex flex-col-reverse lg:flex-row lg:h-screen lg:overflow-hidden">
      <div className="w-full h-screen lg:w-1/2 lg:fixed lg:left-0 lg:top-0">
        <img
          src={vegasImage}
          alt="Vegas Conference 2026 Banner"
          className="w-full h-full object-fit"
        />
      </div>
      <div className="w-full lg:w-1/2 lg:ml-auto min-h-screen lg:overflow-y-auto">
        <VegasBackground>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-12">
            <VegasHeader
              title="VEGAS CONFERENCE 2027"
              tagline="THE POWER OF M.E."
              subTagline="ONE TEAM. ONE MISSION."
            />

            <Stepper currentStep={step} steps={['Details', 'Payment']} />

            {/* STEP 1 */}
            {step === 1 && (
              <StepWrapper className="flex flex-col gap-6 w-full">
                <PersonalInfo
                  primaryPerson={form.primaryPerson}
                  company={form.company}
                  address={form.address}
                  city={form.city}
                  state={form.state}
                  zip={form.zip}
                  setForm={setForm}
                  form={form}
                  showError={!isStep1Valid}
                />

                <AttendanceDetails
                  isAttending={form.isAttending}
                  totalPersons={form.totalPersons}
                  setIsAttending={(value) => setForm({ ...form, isAttending: value })}
                  setTotalPersons={(value) => setForm({ ...form, totalPersons: value })}
                />

                <AdditionalPersons
                  additionalPersons={form.additionalPersons}
                  isAttending={form.isAttending}
                  updateAdditionalPerson={(idx, key, value) => {
                    const updated = [...form.additionalPersons];
                    updated[idx][key] = value;
                    setForm({ ...form, additionalPersons: updated });
                  }}
                  showError={!isStep1Valid}
                />
              </StepWrapper>
            )}

            {/* STEP 2 */}
            {step === 2 && (
              <StepWrapper className="flex flex-col gap-8 w-full">
                <SectionCard
                  icon={FaCreditCard}
                  title="Payment"
                  subtitle="Review your details and complete your payment."
                >
                  <PaymentSummary form={form} totalAmount={totalAmount} />

                  {clientSecret && (
                    <Elements
                      stripe={stripePromise}
                      options={{
                        clientSecret,
                        appearance: { theme: 'stripe' },
                        fields: {
                          billingDetails: {
                            name: 'auto',
                            email: 'auto',
                            address: {
                              postalCode: 'auto',
                              line1: 'never',
                              city: 'never',
                              state: 'never',
                              country: 'never'
                            }
                          }
                        }
                      }}
                    >
                      <PaymentForm
                        receiptEmail={form.primaryPerson.email}
                        setStep={setStep}
                        setForm={setForm}
                      />
                    </Elements>
                  )}
                </SectionCard>
              </StepWrapper>
            )}

            <VegasFooterButtons
              showBack={step > 1}
              showContinue={step < 2}
              disabled={step === 1 && !isStep1Valid}
              onBack={() => setStep(step - 1)}
              onContinue={() => setStep(2)}
            />
          </div>
        </VegasBackground>
      </div>
    </div>
  );
};

export default Body;
